import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { Models } from '../../models/global.models';

function createInitialState(): Models.LeadForm {
  return <Models.LeadForm>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'lead-store' })
export class LeadStore extends Store<Models.LeadForm> {
  constructor() {
    super(createInitialState());
  }
}
